<mat-sidenav-container style="height:100%;">
  <mat-sidenav #sidenav mat-component-id="sidenav" [(opened)]="provisioned" mode="side" class="ecoehs-sidenav">
    <mat-nav-list>
      <a mat-list-item routerLink="overview" routerLinkActive="active" id="sideNavItemOverView">Overview</a>
    </mat-nav-list>
    <mat-nav-list>
      <a mat-list-item routerLink="modules" routerLinkActive="active" id="sideNavItemModules">Modules</a>
      <a mat-list-item routerLink="lists" routerLinkActive="active" id="sideNavItemLists">Lists</a>
      <a [class.disable-nav]="!permissionService.hasPermission(permissions.imports)" mat-list-item routerLink="imports" routerLinkActive="active" id="sideNavItemImports">Imports</a>
      <a [class.disable-nav]="!permissionService.hasPermission(permissions.feeds)" mat-list-item routerLink="feeds" routerLinkActive="active" id="sideNavItemFeeds">Feeds</a>
      <a mat-list-item routerLink="languages" routerLinkActive="active" id="sideNavItemLanguages">Languages</a>
      <a [class.disable-nav]="!permissionService.hasPermission(permissions.access)" mat-list-item routerLink="permissions" routerLinkActive="active" id="sideNavItemPermissions">Access</a>
      <a mat-list-item routerLink="hierarchy-attributes" routerLinkActive="active" id="sideNavItemHierarchyAttributes">Hierarchy Attributes</a>
      <a [class.disable-nav]="!permissionService.hasPermission(permissions.matrixConfig)" mat-list-item routerLink="matrix" routerLinkActive="active" id="sideNavItemMatrix">Matrix</a>
      <a [class.disable-nav]="!permissionService.hasPermission(permissions.featureFlags)" mat-list-item routerLink="feature-flags" routerLinkActive="active" id="sideNavItemFeatureFlags">Feature Flags</a>
    </mat-nav-list>
    <mat-nav-list>
      <a mat-list-item routerLink="packages" routerLinkActive="active" id="sideNavItemPackages">Packages</a>
      <a mat-list-item routerLink="releases" routerLinkActive="active" id="sideNavItemReleases">Releases</a>
      <a mat-list-item routerLink="comparechanges" routerLinkActive="active" id="sideNavItemCompareChanges">Compare Changes</a>
    </mat-nav-list>
    <mat-nav-list>
      @if (hasClonePermission()) {
        <a mat-list-item routerLink="clone" routerLinkActive="active" id="sideNavItemClone">Clone Tenant</a>
      }
      <a [class.disable-nav]="!permissionService.hasPermission(permissions.copyConfig)" mat-list-item routerLink="copyconfig" routerLinkActive="active" id="sideNavItemCopy">Copy Config</a>
      @if (showDelete()) {
        <a [class.disable-nav]="isTenantLive()" mat-list-item routerLink="delete" routerLinkActive="active" id="sideNavItemDelete" class="delete-item">
          <mat-icon>delete</mat-icon>
          <span>Delete</span>
        </a>
      }
      <a [class.disable-nav]="!permissionService.hasPermission(permissions.maintenance)" mat-list-item routerLink="maintenance" routerLinkActive="active" id="sideNavItemMaintenance">Maintenance</a>
      @if (permissionService.hasPermission(permissions.removeData)) {
        <a mat-list-item routerLink="purge-data" routerLinkActive="active" id="sideNavItemPurgeData">Remove Data</a>
      }
    </mat-nav-list>
  </mat-sidenav>
  <router-outlet></router-outlet>
</mat-sidenav-container>
